import { ValidationInputType } from "@generation/core";
import { translate } from "../Locales/translator";
import { AbstractCrossFieldValidation } from "./AbstractCrossFieldValidation";
import { CustomErrorMessage } from "./ValidationHelper";

export class IsSameValueValidation extends AbstractCrossFieldValidation {
  key = "isSameValue";

  constructor(
    readonly valueToCheck: string,
    readonly firstLabel: string,
    private readonly required = true,
    customErrorMessage?: CustomErrorMessage
  ) {
    super(customErrorMessage);
  }

  validate = (input: ValidationInputType) => {
    if (!this.required && (input === "" || input === undefined || input === null)) {
      return true;
    }

    return this.getValues(this.valueToCheck) === input;
  };

  defaultMessage = (label: string): string => 
    translate("Generation_Form_{label}IsNotEqualTo{firstLabel}", { label: label, firstLabel: this.firstLabel });
}
